export const getDatasetId = (): string | null => {
    return new URLSearchParams(location.search).get('datasetId')
}